import React, { useCallback } from 'react'
import type { TaskStatusActionConfig } from '@ztechapps/common.contract'
import { TaskStatusActionsEditor } from './TaskStatusActionsEditor'

export type TaskStatusActionsTabProps = {
  taskId: string
  statusActions?: TaskStatusActionConfig[]
  canEdit?: boolean
  onUpdated?: () => void
}

export const TaskStatusActionsTab = ({
  taskId,
  statusActions,
  canEdit = false,
  onUpdated,
}: TaskStatusActionsTabProps) => {
  const handleSave = useCallback(() => {
    onUpdated?.()
  }, [onUpdated])

  return (
    <TaskStatusActionsEditor
      taskId={taskId}
      currentStatusActions={statusActions}
      onSave={handleSave}
      disabled={!canEdit}
    />
  )
}
